export const ALERT_TYPE_CHANNELS = {
  default: [null],
  email: ["email"],
  mobileApps: ["android", "ios"]
};

export const MOBILE_APP_CHANNELS = ALERT_TYPE_CHANNELS.mobileApps;

export const ALERT_MANAGEMENT_ALERT_TYPES = [
  {
    name: "Turn on / Turn off",
    channels: ALERT_TYPE_CHANNELS.default
  },
  {
    name: "Email",
    channels: ALERT_TYPE_CHANNELS.email
  },
  {
    name: "Mobile apps",
    channels: ALERT_TYPE_CHANNELS.mobileApps
  }
];
